export enum CollapsibleState {
  None = "none",
  Collapsed = "collapsed",
  Expanded = "expanded",
  Full = "full",
}

/** Whether a node's collapsible state counts as open (expanded or fully expanded). */
export function isCollapsibleExpanded(state: CollapsibleState): boolean {
  return state === CollapsibleState.Expanded || state === CollapsibleState.Full;
}
